import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { ClientDetailed } from '@/schemas/API/GET/client/response';

/**
 * Hook that fetches client based on the clientId in the URL.
 */
const useClient = () => {
  const { clientId } = useParams<{ clientId: string }>();

  const {
    data: client,
    error,
    mutate,
  } = useSWR<ClientDetailed>(
    clientId ? `/clients/${clientId}` : null,
    getFetcher
  );

  return {
    client,
    error,
    mutate,
  };
};

export default useClient;
